import React from 'react'
import PropTypes from 'prop-types'
import { domains } from '../../lib/config'
import variables from '../../theme/variables'

class Loading extends React.Component {
  static propTypes = {
    color: PropTypes.string,
    isLoading: PropTypes.bool,
    message: PropTypes.string,
  }
  static defaultProps = {
    isLoading: false,
    color: variables.colors.secondStepOrange,
    message: 'Loading...',
  }

  render = () => {
    const { isLoading, color, message } = this.props
    if (!isLoading) return null
    return (
      <div>
        <div className="loading-outer">
          <div className="loading-inner">
            <img
              alt=""
              src={`${domains.CDN_DOMAIN}/assets/img/secondstep-logo-loader.png`}
            />
            <h5 className="loading-message">
              <div className="loading-indicator" />
              {message}
            </h5>
          </div>
        </div>
        <style>{`
          .loading-outer {
            height: 100%;
            left: 0;
            position: fixed;
            top: 0;
            width: 100%;
            background: rgba(255, 255, 255, 0.8);
            z-index: 99999;
          }

          .loading-inner {
            margin-top: calc(35vh);
            text-align: center;
          }

          .loading-message {
            color: ${color} !important;
          }

          .loading-indicator {
            position: relative;
            display: inline-block;
            left: -2rem;
            top: -2rem;
          }

          .loading-indicator:before {
            position: absolute;
            content: '';
            display: block;
            top: 0;
            width: 15px;
            height: 15px;
            border-radius: 50%;
            background-color: ${color};
            -webkit-transform-origin: 50%;
            transform-origin: 50%;
            -webkit-animation: bounce 500ms alternate infinite ease;
            animation: bounce 500ms alternate infinite ease;
          }

          @-webkit-keyframes bounce {
            0% {
              top: 30px;
              height: 5px;
              border-radius: 60px 60px 20px 20px;
              -webkit-transform: scaleX(2);
              transform: scaleX(2);
            }
            35% {
              height: 15px;
              border-radius: 50%;
              -webkit-transform: scaleX(1);
              transform: scaleX(1);
            }
            100% {
              top: 0;
            }
          }

          @keyframes bounce {
            0% {
              top: 30px;
              height: 5px;
              border-radius: 60px 60px 20px 20px;
              -webkit-transform: scaleX(2);
              transform: scaleX(2);
            }
            35% {
              height: 15px;
              border-radius: 50%;
              -webkit-transform: scaleX(1);
              transform: scaleX(1);
            }
            100% {
              top: 0;
            }
          }
        `}</style>
      </div>
    )
  }
}

export default Loading
